
export const portfolioCategories = [
    "all",
    "websites",
    "applications",
    "games",
    "addons",
    "others",
] as const;

export type PortfolioCategory = typeof portfolioCategories[number];


export interface PortfolioItem {
    key: string;
    slug: string;
    title: string;
    type: "website" | "application" | "game" | "addon" | "system" | "class";
    category: PortfolioCategory[];
    image: string;
    detailImage?: string;
    link: string;
    externalLink?: string;
    technologies?: string[];
    date?: string;
    status?: "Finished" | "In Progress" | "Maintained";
}

export const portfolioItems: PortfolioItem[] = [
    {
        key: "xfiveplay",
        slug: "xfiveplay",
        title: "xFivePlay",
        type: "website",
        category: ["websites"],
        image: "/images/projects/xfiveplay.png",
        detailImage: "/images/projects/xfiveplay-1.png",
        link: "/projects/xfiveplay",
        technologies: ["PHP", "HTML", "CSS", "Bootstrap", "jQuery", "MySQL"],
        date: "2019",
        status: "Finished",
    },
    {
        key: "xfiverecords",
        slug: "xfiverecords",
        title: "xFiveRecords",
        type: "website",
        category: ["websites"],
        image: "/images/projects/xfiverecords.png",
        detailImage: "/images/projects/xfiverecords-1.png",
        link: "/projects/xfiverecords",
        technologies: ["PHP", "HTML", "CSS", "Bootstrap", "JavaScript"],
        date: "2018",
        status: "Finished",
    },
    {
        key: "smartlinks",
        slug: "smartlinks",
        title: "SmartLinks",
        type: "website",
        category: ["websites"],
        image: "/images/projects/smartlinks.png",
        detailImage: "/images/projects/smartlinks-1.png",
        link: "/projects/smartlinks",
        technologies: ["PHP", "Laravel", "Vue.js", "MySQL"],
        date: "2020",
        status: "Finished",
    },
    {
        key: "djkondzio",
        slug: "djkondzio",
        title: "DJ Kondzio",
        type: "website",
        category: ["websites"],
        image: "/images/projects/djkondzio.png",
        detailImage: "/images/projects/djkondzio-1.png",
        link: "/projects/djkondzio",
        externalLink: "https://djkondzio.com",
        technologies: ["HTML", "SCSS", "JavaScript", "PHP"],
        date: "2017",
        status: "Finished",
    },
    {
        key: "xfivebot",
        slug: "xfivebot",
        title: "xFiveBot",
        type: "application",
        category: ["applications"],
        image: "/images/projects/ts-projects.png",
        detailImage: "/images/projects/ts-projects-1.png",
        link: "/projects/xfivebot",
        technologies: ["PHP", "TeamSpeak API", "MySQL"],
        date: "2018",
        status: "Finished",
    },
    {
        key: "waf",
        slug: "waf",
        title: "WAF",
        type: "system",
        category: ["applications"],
        image: "/images/projects/waf.png",
        detailImage: "/images/projects/waf-1.png",
        link: "/projects/waf",
        technologies: ["Node.js", "Express", "Redis", "Lua"],
        date: "2021",
        status: "Maintained",
    },
    {
        key: "zawneun",
        slug: "zawneun",
        title: "Zawneun",
        type: "website",
        category: ["websites"],
        image: "/images/projects/zawneun.png",
        detailImage: "/images/projects/zawneun-1.png",
        link: "/projects/zawneun",
        technologies: ["HTML", "CSS", "JavaScript"],
        date: "2019",
        status: "Finished",
    },
    {
        key: "brq_design",
        slug: "brq-design",
        title: "BRQ Design",
        type: "website",
        category: ["websites"],
        image: "/images/projects/brq-design.png",
        detailImage: "/images/projects/brq-design-1.png",
        link: "/projects/brq-design",
        technologies: ["HTML", "CSS", "jQuery"],
        date: "2018",
        status: "Finished",
    },
    {
        key: "css_slider",
        slug: "css-slider",
        title: "CSS Slider",
        type: "addon",
        category: ["addons"],
        image: "/images/projects/css-slider.png",
        detailImage: "/images/projects/css-slider-1.png",
        link: "/projects/css-slider",
        technologies: ["CSS3", "HTML5"],
        date: "2017",
        status: "Finished",
    },
    {
        key: "zoomix",
        slug: "zoomix",
        title: "Zoomix",
        type: "website",
        category: ["websites"],
        image: "/images/projects/zoomix.png",
        detailImage: "/images/projects/zoomix-1.png",
        link: "/projects/zoomix",
        technologies: ["HTML", "CSS", "Bootstrap", "JavaScript"],
        date: "2018",
        status: "Finished",
    },
    {
        key: "apps_panel",
        slug: "apps-panel",
        title: "Apps Panel",
        type: "website",
        category: ["websites"],
        image: "/images/projects/web-projects.png",
        link: "/projects/apps-panel",
        technologies: ["React", "Node.js", "MongoDB"],
        date: "2022",
        status: "Finished",
    },
    {
        key: "uptime",
        slug: "uptime",
        title: "Uptime",
        type: "system",
        category: ["applications"],
        image: "/images/projects/uptime.png",
		detailImage: "/images/projects/uptime-1.png",
        link: "/projects/uptime",
        technologies: ["TypeScript", "NestJS", "PostgreSQL", "Redis", "Vue", "Tailwind CSS"],
        date: "2026",
        status: "Finished",
    },
    {
        key: "authguard",
        slug: "authguard",
        title: "AuthGuard",
        type: "system",
        category: ["applications"],
        image: "/images/projects/web-projects.png",
        link: "/projects/authguard",
        technologies: ["TypeScript", "NestJS", "Fastify", "PostgreSQL", "Redis", "React", "Tailwind CSS"],
        date: "2026",
        status: "Finished",
    },
    {
        key: "squirreldocs",
        slug: "squirrel-docs",
        title: "Squirrel Docs",
        type: "website",
        category: ["websites"],
        image: "/images/projects/squirrel-docs.png",
		detailImage: "/images/projects/squirrel-docs-1.png",
        link: "/projects/squirrel-docs",
        technologies: ["Nuxt", "Vue", "TypeScript", "Tailwind CSS", "Markdown"],
        date: "2026",
        status: "Finished",
    },
    {
        key: "thunder_music_festival",
        slug: "thunder-music-festival",
        title: "Thunder Music Festival",
        type: "website",
        category: ["websites"],
        image: "/images/projects/thunder-music-festival.png",
		detailImage: "/images/projects/thunder-music-festival-1.png",
        link: "/projects/thunder-music-festival",
        technologies: ["TypeScript", "React", "Tailwind CSS"],
        date: "2025",
        status: "Finished",
    },
    {
        key: "crowdquant",
        slug: "crowdquant",
        title: "CrowdQuant",
        type: "application",
        category: ["applications"],
        image: "/images/projects/crowdquant.png",
		detailImage: "/images/projects/crowdquant-1.png",
        link: "/projects/crowdquant",
        technologies: ["Vue.js", "Python", "AI"],
        date: "2026",
        status: "Finished",
    },
    {
        key: "catfaceid",
        slug: "catfaceid",
        title: "CatFaceID",
        type: "application",
        category: ["applications"],
        image: "/images/projects/catfaceid.png",
		detailImage: "/images/projects/catfaceid-1.png",
        link: "/projects/catfaceid",
        technologies: ["Vue 3", "Python", "Tauri", "AI"],
        date: "2026",
        status: "Finished",
    },
    {
        key: "better_facebook",
        slug: "better-facebook",
        title: "Better Facebook",
        type: "website",
        category: ["websites"],
        image: "/images/projects/better-fb.png",
        detailImage: "/images/projects/better-fb-1.png",
        link: "/projects/better-facebook",
        technologies: ["TypeScript", "NestJS", "Next.js", "Tailwind CSS", "MySQL"],
        date: "2026",
        status: "Finished",
    },
    {
        key: "tic_tac_toe",
        slug: "tic-tac-toe",
        title: "Tic Tac Toe",
        type: "game",
        category: ["games"],
        image: "/images/projects/tic-tac-toe.png",
        detailImage: "/images/projects/tic-tac-toe-1.png",
        link: "/projects/tic-tac-toe",
        technologies: ["JavaScript", "HTML5 Canvas"],
        date: "2016",
        status: "Finished",
    },
    /*{
        key: "php_session",
        slug: "php-session",
        title: "PHP Session Class",
        type: "class",
        category: ["others"],
        image: "/images/projects/other-projects.png",
        link: "/projects/php-session-class",
        externalLink: "https://github.com/DevDJpl/php-session-class",
        technologies: ["PHP"],
        date: "2017",
        status: "Finished",
    },
    {
        key: "php_request",
        slug: "php-request",
        title: "PHP Request Class",
        type: "class",
        category: ["others"],
        image: "/images/projects/other-projects.png",
        link: "/projects/php-request-class",
        externalLink: "https://github.com/DevDJpl/php-request-class",
        technologies: ["PHP"],
        date: "2017",
        status: "Finished",
    },*/
];
